export default {
  choose: {
    title: 'Remover {{name}} como proprietário',
    title_no_owner: 'Escolha um proprietário para {{restaurant}}',
    description: 'Escolha quem assume o lugar de {{name}}, ou deixe {{restaurant}} sem proprietário por agora.',
    description_no_owner: '{{restaurant}} não tem proprietário. Escolha alguém da equipa ou uma pessoa nova.',
    new_owner: 'Novo proprietário',
    previous_owner: '{{name}} após a alteração',
  },
  options: {
    team: {
      title: 'Alguém da equipa',
      loading: 'A carregar a equipa…',
      description_one: 'Qualquer Operador ou Funcionário, {{count}} pessoa.',
      description_other: 'Qualquer Operador ou Funcionário, {{count}} pessoas.',
      empty: 'Ainda não há mais ninguém na equipa.',
      search: 'Pesquisar na equipa por nome ou email',
      no_match: 'Ninguém na equipa corresponde a “{{query}}”.',
    },
    new: {
      title: 'Uma pessoa nova',
      description: 'Passa a ser proprietário de imediato e recebe os dados de acesso por email.',
    },
    none: {
      title: 'Sem proprietário por agora',
      description: 'Escolha um proprietário mais tarde. Até lá, {{restaurant}} fica sem proprietário.',
    },
    keep: {
      title: 'Continua na equipa como Operador',
      description: 'Mantém o acesso aos restaurantes que gere atualmente.',
    },
    remove: {
      title: 'Removido da equipa',
      description: 'Perde de imediato o acesso ao painel.',
    },
  },
  roles: {
    operator: 'Operador',
    employee: 'Funcionário',
  },
  fields: {
    first_name: 'Nome próprio',
    last_name: 'Apelido',
    email: 'Email',
  },
  email_errors: {
    invalid_email: 'Introduza um email válido, como nome@exemplo.com.',
    email_is_owner: '{{name}} já é o proprietário.',
    email_is_manager: '{{name}} já faz parte da equipa.',
    email_taken: 'Alguém fora desta equipa já inicia sessão com este email. Utilize um email diferente.',
  },
  confirm: {
    title: 'Remover {{name}} como proprietário?',
    title_no_owner: 'Tornar {{name}} o proprietário?',
    description_both: 'Ambas as alterações acontecem em conjunto. Se uma falhar, nada é alterado.',
    description: 'Verifique a alteração antes de confirmar.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> fica sem proprietário até escolher um. Tudo o que precisa do proprietário fica a aguardar até lá.',
    new: '<b>{{name}}</b> passa a ser de imediato o proprietário de {{restaurant}}.',
    email:
      'Os dados de acesso são enviados para <b>{{email}}</b>. Verifique-o: quem tiver este email pode iniciar sessão como proprietário.',
    team: '<b>{{name}}</b> passa a ser o proprietário de {{restaurant}}.',
    group_access:
      'Como proprietário, tem acesso a todos os restaurantes de {{group}}, o que pode ser mais do que tem atualmente.',
    keep: '<b>{{name}}</b> continua na equipa como Operador.',
    remove: '<b>{{name}}</b> é removido da equipa e deixa de poder iniciar sessão.',
  },
  error: {
    title: 'Não foi possível alterar o proprietário.',
    description: 'Nada foi alterado. Tente novamente ou contacte o suporte se continuar a falhar.',
  },
  buttons: {
    close: 'Fechar',
    continue: 'Continuar',
    cancel: 'Cancelar',
    back: 'Voltar',
    remove_as_owner: 'Remover como proprietário',
    make_owner: 'Tornar proprietário',
    saving: 'A guardar…',
    try_again: 'Tentar novamente',
    choose_instead: 'Escolher {{name}} em alternativa',
    invite_instead: 'Convidar uma pessoa nova em alternativa',
  },
};
